(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-avaliability-notification-drawer"] && !Shopify.designMode) return;
  try {
    function applyWaitlistCampaignTag() {
    const params = new URLSearchParams(window.location.search);
    const campaignAttribution = [params.get('utm_source'), params.get('utm_campaign')]
      .filter(Boolean)
      .join(' ')
      .toLowerCase();

    if (!campaignAttribution.includes('helge')) return;

    document.querySelectorAll('.avaliability-notification-form input[name="contact[tags]"]').forEach((input) => {
      const tags = input.value
        .split(',')
        .map((tag) => tag.trim())
        .filter(Boolean);

      if (!tags.includes('Helge campaign')) {
        tags.push('Helge campaign');
        input.value = tags.join(', ');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyWaitlistCampaignTag);
  } else {
    applyWaitlistCampaignTag();
  }
  } catch(e) { console.error(e); }
})();

})();
